import React, { HTMLProps } from 'react';
import './ReadOnlyField.scss';

type ReadOnlyFieldProps = HTMLProps<HTMLDivElement> & {
  id?: string;
  schema?: any;
  value: any;
  field?: any;
  forceLabel?: string;
  emptyValue?: string;
};

const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({
  id,
  schema,
  value,
  field,
  forceLabel,
  emptyValue = '-',
  className,
}) => {
  let field2 = field ?? schema?.fields[id ?? ''];

  const label = forceLabel || field2?.describe().meta.label;
  const isRequired = field2
    ?.describe()
    .tests.some((t: any) => t.name === 'required');

  let valueLabel;

  if (!!value) {
    valueLabel = value;
  } else if (isRequired) {
    valueLabel = 'Incomplete';
  } else {
    valueLabel = emptyValue;
  }

  return (
    <div className="read-only-field">
      <span>{label}</span>
      <div className="dashed-line"></div>
      <span className={`value ${isRequired && !value && 'incomplete'} ${className ?? ''}`}>
        {valueLabel}
      </span>
    </div>
  );
};

export default ReadOnlyField;
